import { format as formatter } from 'date-fns';
import isToday from 'date-fns/is_today';
import isYesterday from 'date-fns/is_yesterday';
import nlLocale from 'date-fns/locale/nl';
export const formatDate = (date, format = 'D MMM YYYY', options = {
  locale: nlLocale
}) => {
  if (isToday(date)) {
    return 'Vandaag';
  }

  if (isYesterday(date)) {
    return 'Gisteren';
  }

  const result = formatter(date, format, options);
  return result.includes('mar') ? result.replace('mar', 'mrt') : result;
};
export const defaultDate = (date, format = 'D MMM YYYY - H:mm', options = {
  locale: nlLocale
}) => {
  const result = formatter(date, format, options);
  return result.includes('mar') ? result.replace('mar', 'mrt') : result;
};